import React from 'react';
import { useUiTheme } from 'framework/uiTheme';
import { DefaultDropdownLayoutProps } from 'framework/form';
import { Filter, useFilterContext, BaseFilterProps } from './FilterContext';
import { FilterCondition } from 'framework/types';

export interface DropDownFilterProps extends BaseFilterProps {
  children: React.ReactElement;
  isSingle?: boolean;
  onChangeCallback?: (filter: Filter) => void;
  labelInDropdown?: string;
  disabled?: any;
  conditionType?: FilterCondition;
}

interface DropDownFilterLayoutProps extends DefaultDropdownLayoutProps, DropDownFilterProps {
  label?: string;
  children: React.ReactElement;
  value?: string;
  getDropdownValue: (multiple: boolean) => string | string[];
  onChangeCallback: (filter: Filter) => void;
}

export type DropDownFilterLayoutType = ReactComponent<DropDownFilterLayoutProps>;

const DropDownFilter = ({
  children,
  source,
  onChangeCallback: parentOnChangeCallback,
  conditionType = FilterCondition.IN,
  ...props
}: DropDownFilterProps) => {
  const { DropDownFilterLayout } = useUiTheme<DropDownFilterLayoutType>();
  const { filterBy, getValue } = useFilterContext();

  const onChangeCallback = (filter: Filter) => {
    filterBy(filter);
  };

  /**
   * Dropdown requires different value format depending on
   * if it's `multiple` or not. This method insures that
   * dropdown receives correct format regardless of stored value format
   *
   * @returns array if `multiple` set to true, plain object otherwise
   */
  const getDropdownValue = (multiple: boolean) => {
    const value = getValue(source, conditionType);
    if (multiple && !Array.isArray(value)) {
      return [value];
    }

    if (!multiple && Array.isArray(value)) {
      return value[0];
    }

    return value;
  };

  return (
    <DropDownFilterLayout
      {...props}
      source={source}
      conditionType={conditionType}
      getDropdownValue={getDropdownValue}
      onChangeCallback={parentOnChangeCallback || onChangeCallback}
    >
      {children}
    </DropDownFilterLayout>
  );
};

export default DropDownFilter;
